import { money, number, percentage } from '../../util/formatters'
import React from 'react'
import { Calculation } from './Calculation'
import { get, getSuffix } from '../../util/kdp_cols'

interface CvrCellProps {
    cvr: number
    orders: number
    clicks: number
}

export const CvrCell = (v: CvrCellProps, extra: any) => {
    const suffix = getSuffix(extra.col?.key)
    const g = (key: string) => get(v, key, suffix)

    let cvr = g('cvr')
    if (extra?.recipe_version === 2) {
        cvr = cvr * 100.0
    }

    const lines = [
        { description: 'Orders', value: number(g('orders'), 0) ?? '' },
        { description: '÷ Clicks', value: number(g('clicks'), 0) ?? '' },
        { description: 'CVR', value: percentage(cvr) ?? '' },
    ]

    return <Calculation lines={lines}>{percentage(cvr)}</Calculation>
}

interface BlendedCvrCellProps {
    blended_cvr: number
    adjusted_orders: number
    clicks: number
}

export const BlendedCvrCell = (
    { blended_cvr, adjusted_orders, clicks }: BlendedCvrCellProps,
    extra: any,
) => {
    if (extra?.recipe_version === 2) {
        blended_cvr = blended_cvr * 100.0
    }

    const lines = [
        { description: 'Adjusted Orders', value: number(adjusted_orders, 0) ?? '' },
        { description: '÷ Clicks', value: number(clicks, 0) ?? '' },
        { description: 'Blended CVR', value: percentage(blended_cvr) ?? '' },
    ]

    return <Calculation lines={lines}>{percentage(blended_cvr)}</Calculation>
}
